(function (){
    'use strict';

    angular
        .module('services')
        .service('TimezoneService', TimezoneService);

    TimezoneService.$inject = ['$http', 'API_BASE'];

    function TimezoneService ($http, API_BASE) {
        var service = this;

        service.getAll = getAll;

        function getAll () {
            return $http.get(API_BASE + '/timezone/list');
        }

    }
})();